import { render, staticRenderFns } from "./DayNameModal.vue?vue&type=template&id=0bb5da8f&"
import script from "./DayNameModal.vue?vue&type=script&lang=js&"
export * from "./DayNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports